import adjustment from './index.js';


const RESET_STATE = state => {
  Object.assign(state, adjustment.getDefaultState());
};

const SET_LOADING_REASONS = (state, loadingReasons)=>{
  state.loadingReasons = loadingReasons
}

const UPDATE_ADJUSTMENT_REASONS = (state, reasons)=>{
  state.reasons = reasons;
}

const INVALIDATE_REASONS = (state) =>{
  state.reasonsOutdated=true;
}

const SET_ADJUSTMENT_PROPERTY = (state, {propName, propVal})=>{
  state.adjustment[propName]=propVal;
}

const SET_ON_PRODUCT = (state, onProduct)=>{
  state.onProduct = onProduct;
}
const SET_ADJUSTED_PRODUCT= (state, product)=>{
  state.adjustedProduct.product = product;
}

const SET_ADJUSTED_PRODUCT_QUANTITY = (state, {adjusted_qty, diff})=>{
  if(state.adjustedProduct.item!=null){
    if(diff!=null){
      state.adjustedProduct.diff = diff
      state.adjustedProduct.adjusted_qty=state.adjustedProduct.item.quantity.onHand+diff;
    }else{
      state.adjustedProduct.adjusted_qty = adjusted_qty;
      state.adjustedProduct.diff = adjusted_qty - state.adjustedProduct.item.quantity.onHand;
    }
  }
}

const SET_ADJUSTED_PRODUCT_ITEMS = (state, productItems)=>{
  state.adjustedProduct.items = productItems;
}

const SET_ADJUSTED_PRODUCT_ITEM = (state, productItem)=>{
  state.adjustedProduct.item = productItem;
  state.adjustedProduct.adjusted_qty = productItem.quantity.onHand;
}

const SET_INVENTORY_ID = (state, inventoryId)=>{
  state.adjustment.inventory_id = inventoryId;
}

const ADD_ADJUSTED_ITEM_TO_ADJUSTMENT = (state, adjustedProduct)=>{
  state.adjustment.items.push(adjustedProduct);
}

export default {
  UPDATE_ADJUSTMENT_REASONS,
  SET_LOADING_REASONS,
  RESET_STATE,
  INVALIDATE_REASONS,
  SET_ADJUSTMENT_PROPERTY,
  SET_ON_PRODUCT,
  SET_ADJUSTED_PRODUCT,
  SET_ADJUSTED_PRODUCT_QUANTITY,
  SET_ADJUSTED_PRODUCT_ITEMS,
  SET_ADJUSTED_PRODUCT_ITEM,
  SET_INVENTORY_ID,
  ADD_ADJUSTED_ITEM_TO_ADJUSTMENT
};
